import NextPrevButtons from './NextPrevButtons';

export default NextPrevButtons;
